export const appPageTransition = {"name":"page","mode":"out-in"}

export const appLayoutTransition = {"name":"layout","mode":"out-in"}

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"name":"author","content":"Vít Husák - Brainz Disruptive"},{"name":"google-site-verification","content":"3Z5uo8DnW-e2byPJL__2e7DqHRIndUqARNai6xoJZZc"},{"key":"keywords","name":"keywords","content":"avu, AVU, akademie, Akademie výtvarných umění"},{"key":"description","name":"description","content":"Web Akademie výtvarných umění."},{"key":"og:url","property":"og:url","content":"https://avu.cz/"},{"key":"og:type","property":"og:type","content":"website"},{"key":"og:title","property":"og:title","content":"avu"},{"key":"og:description","property":"og:description","content":"Web Akademie výtvarných umění."},{"key":"og:image","property":"og:image","content":"/favicon/android-chrome-512x512.png"},{"key":"og:site_name","property":"og:site_name","content":"Akademie výtvarných umění"},{"key":"twitter:domain","property":"twitter:domain","content":"avu.cz"},{"key":"twitter:url","property":"twitter:url","content":"https://avu.cz/"},{"key":"twitter:card","property":"twitter:card","content":"summary_large_image"},{"key":"twitter:title","property":"twitter:title","content":"avu"},{"key":"twitter:description","property":"twitter:description","content":"Web Akademie výtvarných umění."},{"key":"twitter:image","property":"twitter:image","content":"/favicon/android-chrome-512x512.png"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon/favicon.ico"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon/favicon-16x16.png"},{"rel":"manifest","href":"/favicon/site.webmanifest"}],"style":[],"script":[],"noscript":[],"title":"avu"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true